module.exports = "<div class=\"donations-progress\">\n  <div class=\"\">\n    <div class=\"progress-sum-block\"><span>{{vm.donationsService.total || 0 | number: 0}}</span> <span class=\"currency\">ש\"ח</span>\n      <div class=\"commitmens-total\">מתוכם <span>{{vm.donationsService.totalCommitmens || 0 | number: 0}} ש\"ח</span> התחייבויות עתידיות</div>\n    </div>\n  </div>\n  <div class=\"progress-summary\">נתרמו ע\"י {{vm.donationsService.totalDonors || 0}} תורמים\n    <!-- ב 23 שעות -->\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/donations-progress/donations-progress.html
// module id = 493
// module chunks = 0